'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2; // get all actions from redux store


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _goals = require('redux/modules/goals');

var goalActions = _interopRequireWildcard(_goals);

var _reactRouter = require('react-router');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Goals = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    goals: state.goals.data
  };
}, goalActions), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Goals, _Component);

  function Goals() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Goals);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Goals.__proto__ || (0, _getPrototypeOf2.default)(Goals)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isEdit: false,
      goals: _this.props.goals.goals || ['', '', ''],
      priorityGoal: _this.props.goals.priorityGoal
    }, _this.handleClickEdit = function () {
      var obj = _this.state;
      obj.isEdit = !obj.isEdit;
      _this.setState(obj);
    }, _this.handleSave = function () {
      var userId = _this.props.user.userId;
      _this.props.updateGoals(userId, _this.state);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj.goals[str] = event.target.value;
      _this.setState(obj);
    }, _this.handlePriorityGoal = function (event) {
      var obj = {};
      obj.priorityGoal = event.target.value;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Goals, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var obj = this.state;
      while (obj.goals.length < 3) {
        obj.goals.push('');
      }
      this.state = obj;
    }

    /* User clicks on edit button */


    /* ****************************** */
    /* HANDLE FORM CHANGE FUNCTIONS   */
    /* ****************************** */

    /* save udated data */


    // without handleChange, form value fields would not change on the front end


    /*
     * Change the priority goal upon selecting a
     * radio button
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Profile.scss');

      return _react2.default.createElement(
        'div',
        null,
        !this.state.isEdit && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: styles.card + ' ' + styles.cardContent },
            _react2.default.createElement(
              'h2',
              { className: styles.orangeText + ' ' + styles.textCenter },
              'My goals'
            ),
            this.state.goals[0] === '' && this.state.goals[1] === '' && this.state.goals[2] === '' && _react2.default.createElement(
              'div',
              { className: styles.textCenter },
              _react2.default.createElement(
                'h3',
                null,
                'No goals have been set yet!'
              ),
              _react2.default.createElement(
                'h4',
                null,
                'Start working through the ',
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/module1' },
                  'Healthy eating habits'
                ),
                ' module to set goals!'
              ),
              _react2.default.createElement('div', { className: styles.spacer20 })
            ),
            this.state.goals.map(function (goal, index) {
              return _react2.default.createElement(
                'div',
                { key: 'goal' + index },
                goal === _this2.props.goals.priorityGoal && goal !== '' && _react2.default.createElement(
                  ReactBootstrap.Row,
                  null,
                  _react2.default.createElement(
                    ReactBootstrap.Col,
                    { md: 10, sm: 10, lg: 10, xs: 10 },
                    _react2.default.createElement(
                      'h3',
                      null,
                      _react2.default.createElement('i', { className: 'fa fa-star ' + styles.orangeText }),
                      '\xA0\xA0\xA0',
                      goal
                    )
                  )
                ),
                goal !== _this2.props.goals.priorityGoal && goal !== '' && _react2.default.createElement(
                  ReactBootstrap.Row,
                  null,
                  _react2.default.createElement(
                    ReactBootstrap.Col,
                    { md: 12, sm: 12, lg: 12 },
                    _react2.default.createElement(
                      'h3',
                      null,
                      goal
                    )
                  )
                )
              );
            }),
            (this.state.goals[0] !== '' || this.state.goals[1] !== '' || this.state.goals[2] !== '') && _react2.default.createElement(
              ReactBootstrap.ButtonToolbar,
              null,
              _react2.default.createElement(
                ReactBootstrap.Button,
                { className: 'pull-right',
                  bsStyle: 'success', onClick: this.handleClickEdit },
                _react2.default.createElement('i', { className: 'fa fa-user-o' }),
                '  Edit goals'
              )
            )
          )
        ),
        this.state.isEdit && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: styles.card + ' ' + styles.cardContent },
            _react2.default.createElement(
              'h2',
              { className: styles.orangeText + ' ' + styles.textCenter },
              'My goals'
            ),
            this.state.goals.map(function (goal, index) {
              return _react2.default.createElement(
                'div',
                { key: 'editgoal' + index },
                _react2.default.createElement(ReactBootstrap.FormControl, { type: 'text', bsSize: 'large', placeholder: 'Set a goal', value: _this2.state.goals[index],
                  onChange: _this2.handleChange.bind(_this2, index) }),
                _react2.default.createElement('br', null)
              );
            }),
            _react2.default.createElement(
              'h5',
              null,
              'Would you like to change your priority goal?'
            ),
            _react2.default.createElement(
              ReactBootstrap.FormGroup,
              { onChange: this.handlePriorityGoal },
              this.state.goals.map(function (goal, index) {
                return _react2.default.createElement(
                  'div',
                  { key: 'priority' + index },
                  goal !== '' && _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'priority', value: goal, checked: goal === _this2.state.priorityGoal },
                    goal
                  )
                );
              })
            ),
            _react2.default.createElement(
              ReactBootstrap.ButtonToolbar,
              null,
              _react2.default.createElement(
                ReactBootstrap.Button,
                { bsStyle: 'success', className: 'pull-right', onClick: function onClick() {
                    _this2.handleClickEdit();_this2.handleSave();
                  } },
                _react2.default.createElement('i', { className: 'fa fa-check' }),
                '  Save'
              )
            )
          )
        )
      );
    }
  }]);
  return Goals;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  goals: _propTypes2.default.object,
  updateGoals: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = Goals;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Profile/Goals.js
// module id = 1224
// module chunks = 0